module.exports = __webpack_public_path__ + "assets/img/0620.18bcb839.png";